// The wallet mark — one glyph, shared by the nav chip and the profile card.
//
// Shared on purpose rather than drawn twice: the chip in the header and the
// badge on the profile are meant to read as the SAME object seen in two places,
// and that only works if the silhouette is literally identical. Change it here
// and both move together.
//
// Same reasoning as components/common/EditIcon on where it comes from: lucide's
// `wallet` shape, drawn inline, because lucide-react isn't a dependency of this
// app and one path doesn't justify adding it. Inherits currentColor.

interface Props {
  size?: number
}

export function WalletIcon({ size = 16 }: Props) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true" focusable="false"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <path d="M19 7V5.5A1.5 1.5 0 0 0 17.5 4H5a2 2 0 0 0 0 4h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6" />
      <path d="M17 14h.01" />
    </svg>
  )
}
